const i18nConfig = {
    locales: ["de", "en"],
    defaultLocale: "de",
    prefixDefault: false,
};
export default i18nConfig;
